import { useState, useEffect } from "react";
import "./SubscribeForm.css";
import toast from "react-hot-toast";

export default function SubscribeForm() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    if (status === "success") {
      toast.success("تم تسجيلك بالكورس");
    }
  }, [status]);
const handleSubmit = async (e) => {
  e.preventDefault();
  setStatus("loading");
  try {
    const res = await fetch("https://course-next-js-rosy.vercel.app/api/email/subscribe", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    const data = await res.json();
    console.log(data); // طباعة الرد للتحقق من التفاصيل
    if (res.ok) {
      setStatus("success");
      setEmail("");
    } else {
      setStatus(data.error || "error");
    }
  } catch (error) {
    console.error('Error:', error); // طباعة الأخطاء إذا حدثت
    setStatus("error");
  }
};

  return (
    <form className="subscribe-form" onSubmit={handleSubmit}>
      <input
        type="email"
        placeholder="أدخل بريدك الإلكتروني"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        className="subscribe-input"
      />
      <button type="submit" className="subscribe-button">
        {status === "loading" ? "جارٍ الإرسال..." : "اشترك الآن"}
      </button>
      {status !== "" && status !== "success" && status !== "loading" && (
        <p className="subscribe-error">حدث خطأ: {status}</p>
      )}
    </form>
  );
}